import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  buildCanonicalPortalUrl,
  isDeprecatedPortalHostname,
} from '../../config/hostApps';

/**
 * No host antigo do portal (ex.: portal-alpha-liart.vercel.app), força
 * navegação hard para portal.marimosca.com.br em qualquer mudança de rota.
 * Os redirects do vercel.json só cobrem reload completo.
 */
const DeprecatedPortalHostRedirect: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isDeprecatedPortalHostname()) {
      return;
    }

    const destination = buildCanonicalPortalUrl(
      location.pathname,
      location.search,
      location.hash,
    );

    if (window.location.href === destination) {
      return;
    }

    window.location.replace(destination);
  }, [location.hash, location.pathname, location.search]);

  return null;
};

export default DeprecatedPortalHostRedirect;
